<template>
  <div class="s1vm-sone-error s1-U__mg--bt64 s1-U__pd16 s1-U__border-solid--1" :class="type" v-show="errors && errors.length">
    <h3>Erro</h3>
    <ul class="errors" v-if="errors">
      <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
    </ul>
  </div>
</template>
<script>
import _ from 'lodash';

export default {
  props: ['errorModel'],
  data: () => ({
    type: null,
    errors: null
  }),
  methods: {
    update(errorModel) {
      if (errorModel.Errors != null && errorModel.Errors) {
        this.type = 'warning';

        if (_.has(errorModel.Errors, 'Business')) {
          this.errors = errorModel.Errors.Business;
        }

        if (_.has(errorModel.Errors, 'ModelState')) {
          this.errors = errorModel.Errors.ModelState;
        }
      } else {
        this.errors = [errorModel.Message];
        this.type = 'warning';
      }
    }
  },
  watch: {
    errorModel: function(errorModel) {
      let _errorModel = null;

      if (errorModel === null) {
        this.erros = null;
        return;
      }

      if (errorModel.Message) {
        _errorModel = errorModel;
      } else if (errorModel.Errors) {
        _errorModel = errorModel;
      } else if (
        errorModel.response &&
        typeof errorModel.response.data === 'string' &&
        errorModel.response.data
      ) {
        if (errorModel.response.headers['content-type'].indexOf('text/html') < 0) {
          _errorModel = { Message: errorModel.response.data };
        } else _errorModel = { Message: this.$t('request.error') };
      } else if (
        errorModel.response &&
        errorModel.response.data &&
        typeof errorModel.response.data === 'object' &&
        errorModel.response.data.Errors
      ) {
        let errors = errorModel.response.data.Errors;
        let errorMsg = '';
        for (let i = 0; i < errors.length; i++) {
          const error = this.$t(`error_code.${errors[i].Code}`);
          errorMsg += `${error}\n`;
        }
        _errorModel = { Message: errorMsg };
      } else if (errorModel.response && errorModel.response.data) {
        _errorModel = { Message: errorModel.response.data };
      } else if (errorModel.response.status == 403) {
        _errorModel = { Message: 'current_user_do_not_have_permission_to_do_this_action' };
      } else {
        _errorModel = { Message: 'Error' };
      }

      this.update(_errorModel);
    }
  }
};
</script>
<style lang="scss">
.s1vm-sone-error {
  &.warning {
    background-color: rgba(255,0,0,0.05);
  }
}
</style>
